import { TimerModule, ButtonModule, RectModule, FormFieldModule} from '@shared/components/games';
import { CommonModule, JsonPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactionCorrectAnswerPreviewComponent } from './reaction-preview/reaction-answer-preview/reaction-answer-preview.component';
import { ReactionControllerComponent } from './reaction-controller/reaction-controller.component';
import { ReactionExamplePreviewComponent } from './reaction-preview/reaction-example-preview/reaction-example-preview.component';
import { ReactionParametersPreviewComponent } from './reaction-preview/reaction-parameters-preview/reaction-parameters-preview.component';
import { ReactionRulesComponent } from './tools/reaction-rules/reaction-rules.component';
import { ReactionSettingsComponent } from './reaction-settings/reaction-settings.component';
import { ReactionUserAnswerPreviewComponent } from './reaction-preview/reaction-user-answer-preview/reaction-user-answer-preview.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import {MatTooltip} from "@angular/material/tooltip";

@NgModule({
  declarations: [
    ReactionControllerComponent,
    ReactionSettingsComponent,
    ReactionRulesComponent,
    ReactionCorrectAnswerPreviewComponent,
    ReactionExamplePreviewComponent,
    ReactionParametersPreviewComponent,
    ReactionUserAnswerPreviewComponent,
  ],
  exports: [
    ReactionControllerComponent,
    ReactionSettingsComponent,
    ReactionRulesComponent,
    ReactionCorrectAnswerPreviewComponent,
    ReactionExamplePreviewComponent,
    ReactionParametersPreviewComponent,
    ReactionUserAnswerPreviewComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    ButtonModule,
    TimerModule,
    RectModule,
    JsonPipe,
    GamesSharedModule,
    FormFieldModule,
    MatTooltip,
  ],
})
export class ReactionModule {}
